<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.18939 5.8335C5.64699 4.8625 6.8817 4.16683 8.33305 4.16683C10.174 4.16683 11.6664 5.28612 11.6664 6.66683C11.6664 7.83303 10.6017 8.81273 9.16157 9.089C8.70957 9.1757 8.33305 9.53993 8.33305 10.0002M8.33301 12.5002H8.34134M15.833 8.3335C15.833 12.4756 12.4751 15.8335 8.33301 15.8335C4.19087 15.8335 0.833008 12.4756 0.833008 8.3335C0.833008 4.19136 4.19087 0.833496 8.33301 0.833496C12.4751 0.833496 15.833 4.19136 15.833 8.3335Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "17",
  },
  height: {
    type: [String, Number],
    default: "17",
  },
  color: {
    type: String,
    default: "currentColor",
  },
  strokeWidth: {
    type: [String, Number],
    default: "1.66667",
  },
});
</script>
